import React, { useState } from 'react';
import CreateAccountForm from '../../components/CreateAccountForm/CreateAccountForm';
import './CreateAccount.scss';
import {API_URL} from '../../utils/axios'
import axios from 'axios'
import { Redirect, Link } from 'react-router-dom';

const CreateAccount = () => {

    const [email, setEmail] = useState("")
    const [password, setPassword] = useState("");
    const [name, setName] = useState("")
    const [mobile, setMobile] = useState("");

    const handleEmailChange = (e) => {
        setEmail(e.target.value)
    }

    const handlePasswordChange = (e) => {
        setPassword(e.target.value);
    }


    const handleNameChange = (e) => {
        setName(e.target.value)
    }

    const handleMobileChange = (e) => {
        setMobile(e.target.value);
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        axios.post(API_URL + '/user/create', {
           email,
           password,
           name,
           phone: mobile
        }).then((response) => {
            window.location = "/";
        }).catch(error => console.log(error))
    }


    if(localStorage.getItem("token")) {
        return <Redirect to="/dashboard"/>
    }

    return (
            <div className="create-account">
                <div className="create-account__form-container">
                    <CreateAccountForm 
                    
                    email={email} 
                    password={password}
                    name={name}
                    mobile={mobile}
                    handleMobileChange={handleMobileChange}
                    handleNameChange={handleNameChange}
                    handleEmailChange={handleEmailChange}
                    handlePasswordChange={handlePasswordChange}
                    handleSubmit={handleSubmit}
                    />
                </div>
                <div className="create-account__alternative-options">
                    <Link to="/" className="create-account__return-login">Return to Login</Link>
                </div>
            </div>
       
    );
};

export default CreateAccount;